import { PathPointDataOutput } from './path-point-data-output.model';


export class TourOutputWithOutStatus implements ITourOutputWithOutStatus {
    /** The auto-generated id of the tour master */
    tour_id!: number;
    /** The auto generated id from company details master */
    company_details_id!: number;
    /** The auto generated id from branch details master */
    branch_detail_id!: number;
    /** The trip type should be Automatic or Manual */
    trip_type!: string;
    /** The auto generated id from vehicle details master */
    vehicle_details_id!: number;
    /** The start date 15 character limit */
    start_date_!: string;
    /** The start date 15 character limit */
    end_date!: string;
    /** The stoppage duration */
    stoppage_duration!: number;
    /** The start point 5000 character limit */
    start_point!: string;
    /** The start point 5000 character limit */
    end_point!: string;
    /** The selected start point lat */
    start_point_lat!: number;
    /** The selected start point long */
    start_point_long!: number;
    /** The selected end point lat */
    end_point_lat!: number;
    /** The selected end point long */
    end_point_long!: number;
    /** The distance */
    distance!: number;
    /** The duration 10 character limit */
    duration!: string;
    /** The tour name 255 character limit */
    tour_name!: string;
    selected_tour_path!: PathPointDataOutput[];
    status!: number;

    constructor(data?: ITourOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_id = _data["tour_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.trip_type = _data["trip_type"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.start_date_ = _data["start_date "];
            this.end_date = _data["end_date"];
            this.stoppage_duration = _data["stoppage_duration"];
            this.start_point = _data["start_point"];
            this.end_point = _data["end_point"];
            this.start_point_lat = _data["start_point_lat"];
            this.start_point_long = _data["start_point_long"];
            this.end_point_lat = _data["end_point_lat"];
            this.end_point_long = _data["end_point_long"];
            this.distance = _data["distance"];
            this.duration = _data["duration"];
            this.tour_name = _data["tour_name"];
            if (Array.isArray(_data["selected_tour_path"])) {
                this.selected_tour_path = [] as any;
                for (let item of _data["selected_tour_path"])
                    this.selected_tour_path!.push(PathPointDataOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TourOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TourOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_id"] = this.tour_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["trip_type"] = this.trip_type;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["start_date "] = this.start_date_;
        data["end_date"] = this.end_date;
        data["stoppage_duration"] = this.stoppage_duration;
        data["start_point"] = this.start_point;
        data["end_point"] = this.end_point;
        data["start_point_lat"] = this.start_point_lat;
        data["start_point_long"] = this.start_point_long;
        data["end_point_lat"] = this.end_point_lat;
        data["end_point_long"] = this.end_point_long;
        data["distance"] = this.distance;
        data["duration"] = this.duration;
        data["tour_name"] = this.tour_name;
        if (Array.isArray(this.selected_tour_path)) {
            data["selected_tour_path"] = [];
            for (let item of this.selected_tour_path)
                data["selected_tour_path"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface ITourOutputWithOutStatus {
    /** The auto-generated id of the tour master */
    tour_id: number;
    /** The auto generated id from company details master */
    company_details_id: number;
    /** The auto generated id from branch details master */
    branch_detail_id: number;
    /** The trip type should be Automatic or Manual */
    trip_type: string;
    /** The auto generated id from vehicle details master */
    vehicle_details_id: number;
    /** The start date 15 character limit */
    start_date_: string;
    /** The start date 15 character limit */
    end_date: string;
    /** The stoppage duration */
    stoppage_duration: number;
    /** The start point 5000 character limit */
    start_point: string;
    /** The start point 5000 character limit */
    end_point: string;
    /** The selected start point lat */
    start_point_lat: number;
    /** The selected start point long */
    start_point_long: number;
    /** The selected end point lat */
    end_point_lat: number;
    /** The selected end point long */
    end_point_long: number;
    /** The distance */
    distance: number;
    /** The duration 10 character limit */
    duration: string;
    /** The tour name 255 character limit */
    tour_name: string;
    selected_tour_path: PathPointDataOutput[];
    status: number;
}

